export const resourceData = {
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  at: "at",
  no: "No",
  ok: "OK",
  or: "OR",
  to: " To ",
  add: "Add",
  age: "Age",
  dob: "Date of birth",
  faq: "FAQs",
  pay: "Pay",
  pnr: "PNR",
  sMS: "SMS",
  seq: "Seq",
  son: "Son",
  yes: "Yes",
  yrs: {
    few: "{} yrs",
    one: "{} yr",
    two: "{} yrs",
    many: "{} yrs",
    zero: "{} yr",
    other: "{} yrs"
  },
  Paid: "Paid",
  _uid: "da066bcf-4479-4feb-8468-1912525a8a1e",
  away: "Seems like you’ve been away. Still looking for flights?",
  back: "Back",
  book: "Book {}",
  chat: "Chat",
  city: "City",
  date: "Date",
  deny: "Deny",
  done: "Done",
  edit: "Edit",
  exit: "Exit",
  from: "From",
  gate: "Gate",
  home: "Home",
  just: "just",
  left: "left",
  meal: "Meal",
  name: "Name",
  none: "None",
  paid: "Paid",
  past: "Past",
  save: "Save",
  seat: "Seat",
  skip: "Skip",
  stop: "Stop",
  view: "View",
  wife: "Wife",
  wifi: "Wifi",
  year: "Year",
  zone: "Zone",
  added: "Added",
  adult: {
    one: "1 Adult",
    zero: "0 Adult",
    other: "{} Adults"
  },
  agree: "I Agree",
  allow: "Allow",
  apply: "Apply",
  cabin: "Cabin",
  clear: "Clear",
  early: "Early",
  email: "Email",
  error: "",
  great: "Great",
  india: "India",
  month: "Month",
  night: "Night",
  phone: "Mobile Number",
  price: "Price",
  reset: "Reset",
  seats: {
    one: "1 seat",
    many: "{} seats",
    zero: "No seat",
    other: "{} seats"
  },
  share: "Share",
  state: "State",
  stops: {
    one: "1 stop",
    two: "2 stops",
    many: "{} stops",
    zero: "Non-stop",
    other: "{} stops"
  },
  tAndC: "T&C",
  today: "Today",
  until: "until",
  years: "Years",
  addOns: "Add-Ons",
  addons: "Add-ons",
  adults: "Adult(s)",
  budget: "Budget",
  button: "Button",
  callUs: "Call us",
  cancel: "Cancel",
  cities: "Cities",
  enable: "Enable",
  extras: "Extras",
  failed: "Failed",
  father: "Father",
  flight: "Flight",
  flying: "Flying {}",
  gender: "Gender",
  goBack: "Go back",
  google: "Google",
  ignore: "Ignore",
  logout: "Logout",
  maxAge: "Maximum age for {name} should be {maximumAge}",
  maxLen: "Max {} characters allowed",
  minAge: "Minimum age for {name} should be {minimumAge}",
  minLen: "Should have at least {} characters",
  modify: "Modify",
  mother: "Mother",
  newKey: "",
  notNow: "Not now",
  onHold: "ON-HOLD",
  onTime: "On Time",
  oneWay: "One Way",
  ontime: "On Time",
  otpMsg: "is your Akasa Air OTP. Do not share it with anyone",
  remove: "Remove",
  rooted: "Rooted",
  saving: "Saving",
  search: "search",
  sector: "Sector",
  signIn: "Sign In",
  signUp: "Sign Up",
  sister: "Sister",
  sortBy: "Sort by",
  submit: "Submit",
  travel: "Travel",
  update: "Update",
  verify: "Verify",
  youPay: "You Pay",
  Connect: "Connecting",
  Through: "Through",
  To_Text: "",
  addMore: "Add More",
  addedOn: "Added on {}",
  address: "Address",
  akasaMe: "Akasa & Me",
  arrival: "Arrival",
  arrived: "Arrived",
  brother: "Brother",
  calling: "Calling",
  checkIn: "Check-in",
  confirm: "Confirm",
  connect: "Connect",
  contact: "Contact",
  country: "Country",
  created: "",
  dayToGo: "days to go",
  delayed: "Delayed",
  eTicket: "eTicket",
  emailId: "Email ID",
  evening: "Evening",
  failure: "Failure",
  flights: "flights",
  gateTNC:
    "Gate is subject to change and will close 25 minutes prior to departure.\nBook on AkasaAir.com or our mobile app for special deals and offers.",
  helpFaq: "FAQ",
  husband: "Husband",
  iAccept: "I accept",
  infants: "Infant(s)",
  kmsFrom: {
    one: "{} km from {}",
    other: "{} kms from {}"
  },
  loading: "Loading",
  mealVeg: "Veg",
  minutes: {
    few: "{} minutes",
    one: "1 minute",
    two: "{} minutes",
    many: "{} minutes",
    zero: "0 minute",
    other: "{} minutes"
  },
  morning: "Morning",
  noBlank: "Cannot be blank",
  noMeals: "No Meals Found. Try a different meal",
  nonStop: "Non-Stop",
  onlyVeg: "Only Veg",
  rateNow: "Rate now",
  restart: "Restart",
  seatFee: "Seat Fee",
  seating: "Seating",
  sendOtp: "Send OTP",
  soldOut: "Sold out",
  success: "Your request has been registered with us. we will get back to you shortly.",
  upgrade: "Upgrade",
  weapons: "Weapons",
  welcome: "Welcome to Akasa",
  writeUs: "Write Us",
  youPaid: "You Paid",
  akasaURL: "AkasaAir.com",
  allGases: "All gases",
  allMeals: "All Meals",
  arriveAt: "Arrive At",
  bookACab: "Book a cab to the airport",
  bookedOn: "Booked on",
  category: "Category",
  children: "Children",
  complete: "complete",
  currency: "Currency",
  dateText: "date",
  daughter: "Daughter",
  departed: "Departed",
  disagree: "I Disagree",
  discount: "Discount",
  download: "Download",
  duration: "Duration",
  eTickets: "eTicket",
  enterOTP: "Enter OTP",
  enterOtp: "Enter OTP",
  enterPNR: "Please enter PNR number",
  faceBook: "Facebook",
  fareNote: "Base Fare, excluding Taxes and Fees",
  fareText: "Fare",
  favorite: "Favorite",
  feedback: "Type your feedback here",
  flyingTo: "Flying To",
  goToHome: "Home",
  included: "Included",
  language: "Select Language",
  lastName: "Last Name",
  loadMore: "Load More",
  lockFare: "Lock fare",
  meAppBar: "Me",
  musicKit: "Sport/Music Equipment",
  needHelp: "Need Help?",
  noThanks: "No, Thanks",
  passport: "Passport",
  password: "Password",
  specialAssistanceReques: "Special Requests",
  pleaseNote: "Please Note",
  modifySpecialRequest: "Add / Remove Special Request",
  specialRequestConfirmed: "Your request is confirmed",
  SpecialRequestDenied: "You have selected an emergency exit seat. For any special assistance please contact our 24x7 Akasa Care Centre +91 9606112131.",
  assistanceResellFailed: "Wheelchair service is currently unavailable on the selected flight. Would you like to continue or cancel and select an alternate flight with special assistance?",
  PassengerName: "Passenger Name",
  serviceUnavailable: "This service is currently unavailable",
  specialAssistanceWCHC: "Please contact our 24x7 <span style='font-weight:600'>Akasa Care Centre</span> to confirm your request.",
  readLess: "Read less",
  readMore: "Read more",
  removing: "Removing",
  security: "Security",
  services: "Services",
  setUpNow: "Add details",
  students: "Students",
  tomorrow: "Tomorrow",
  upcoming: "Upcoming",
  updating: "Updating",
  username: "User Name",
  viewMore: "View more",
  whatsapp: "WhatsApp",
  yourName: "Your Name",
  yourText: "Your",
  addflight: "Add Flight",
  afternoon: "Afternoon",
  allAddOns: "All Akasa Add-Ons",
  bestValue: "Best Value",
  bookAgain: "Book Again",
  cafeAkasa: "Café Akasa",
  cancelled: "Cancelled",
  checkedin: "Checked-in",
  closeText: "Close",
  component: "masterData",
  customize: "Customize",
  departure: "Departure",
  duplicate: "Duplicate",
  earnPoint: "Earn points on every booking",
  entireRow: "Entire row",
  firstName: "First Name",
  groupType: "Group Type",
  gstNumber: "GST Number (enter in UPPERCASE)",
  hideFares: "Hide fares",
  literalTo: "to",
  mobileApp: "Mobile app",
  multiCity: "Multicity",
  onwardTxt: "Onward",
  otpSentTo: "OTP sent to",
  passenger: "Passenger",
  phoneCode: "Phone Code",
  powerBank: "Power bank",
  poweredBy: "Powered by",
  priceonly: "{} only",
  promoCode: "Promo Code",
  removeAll: "Remove All",
  removeMsg: "Are you sure you want to remove",
  resendOTP: "Resend OTP",
  resendOtp: "Resend OTP",
  returnTxt: "Return",
  roundTrip: "Round Trip",
  searchFor: "Search For {}",
  seatAisle: "Aisle",
  seatsLeft: {
    one: "1 seat left {}",
    two: "2 seat left {}",
    many: "{} seats left {}",
    zero: "No seat left at {}",
    other: "{} seats left {}"
  },
  seatsOnly: "seat(s)",
  selectAll: "Select all",
  selectCta: "Select",
  startOver: "Start Over",
  subscribe: "Subscribe",
  tripTotal: "Total for {}",
  yesterday: "Yesterday",
  Connecting: "",
  addDetails: "Add details",
  addonsOnly: "addon(s)",
  akasaSaver: "Saver",
  akasaValue: "Seat & Meal Deal",
  altEmailId: "Alt Email ID",
  bookAppBar: "Book",
  bookedDate: "Booked date",
  checkInFor: "Check-in for",
  confirmOTP: "Confirm OTP",
  confirmOtp: "Confirm OTP",
  currencies: "Currencies",
  departFrom: "Depart From",
  disConnect: "Disconnect",
  disconnect: "Disconnect",
  earnPoints: {
    one: "Earn 1 point",
    many: "Earn {} points",
    zero: "No points available",
    other: "Earn {} points"
  },
  eightChars: "8 characters",
  explosives: "Explosives",
  fareLocked: "Locked",
  flyingFrom: "Flying From",
  genderMale: "Male",
  goToAddOns: "Yes, Go to Akasa Add-Ons",
  gstDetails: "GST details (IN UPPERCASE)",
  gstInvoice: "GST invoice",
  homeAppBar: "Home",
  hopOnboard: "Hop Onboard",
  inDuration: " in {}.",
  invalidAge: "Invalid age",
  invalidOTP: "Invalid OTP",
  invalidOtp: "Either OTP is incorrect or expired",
  invalidPNR: "Invalid PNR",
  jailBroken: "Jail broken",
  lowestFare: "Lowest fare",
  mealNonVeg: "Non-Veg",
  mealPlural: {
    few: "{} Meals",
    one: "1 Meal",
    two: "{} Meals",
    many: "{} Meals",
    zero: "No meal",
    other: "{} Meals"
  },
  mealsAdded: "Meals Added",
  moreAppBar: "More",
  myBookings: "My bookings",
  noStations: "No Stations found",
  onWhatsApp: "on WhatsApp",
  onWhatsapp: " on Whatsapp",
  onwardText: "Onward",
  passengers: "Passenger(s)",
  paxLiteral: "Pax",
  plugPoints: "Plug Points",
  priceRange: "Price range",
  primaryPnr: "Primary PNR",
  returnDate: "Return Date",
  returnText: "Return",
  seatMiddle: "Middle",
  seatWindow: "Window",
  seatsTitle: "Select Your Seat",
  seatsTotal: "Seats Total",
  selectDate: "Please select date",
  selectFare: "Select Fare",
  selectMeal: "Select meal",
  selectPhot: "Select photo",
  selectSeat: "Select Your Seat",
  sequenceNo: "Sequence no.",
  stopOverAt: "Stopover at",
  stopsCount: "Stops",
  switchLang: "Switch Language",
  vegetarian: "Vegetarian",
  windowSeat: "Window Seat",
  withInfant: "With Infant",
  aadhaarCard: "Aadhaar Card",
  addDocument: "Add Document",
  addTraveler: "Add Traveller",
  adultPlural: {
    one: "1 Adult",
    two: "2 Adults",
    many: "{} Adults",
    zero: "No Adult",
    other: "{} Adults"
  },
  allJourneys: "All Journeys",
  armedForces: "Armed Forces",
  arrivalDate: "Return Date",
  atLeast1Num: "Atleast one number",
  bannerLogin: "Login",
  bookAFlight: "Book a flight",
  changeDates: "Change dates",
  changePhoto: "Change photo",
  changeseats: "Change seats",
  checkedinon: "Checked-in on {}",
  continueTxt: "Continue",
  countryCode: "Country Code",
  editDetails: "Edit details",
  editProfile: "Edit my profile",
  emailExists: "Email already exists",
  fareSummary: "Fare summary",
  gateSubject: "Gate is subject to change and will close",
  genderOther: "Other",
  handBaggage: "Hand Baggage",
  helpContact: "Contact",
  helpSupport: "Support",
  invalidName: "Invalid Name",
  invalidTrip: "Invalid trip type",
  invalidUser: "Invalid user",
  literalLeft: "left",
  lockFareFor: "Lock fare for ",
  makePayment: "Make Payment",
  memberSince: "Signed up since {}",
  mostPopular: "Most Popular",
  myDocuments: "My documents",
  newMoreHelp: "New More help ?",
  noIDontWant: "No, I don’t want",
  onFirstTrip: "on your first trip",
  phoneExists: "Phone already exists",
  quickRebook: "Quick rebook",
  rateNowDesc: "Loving the experience? Rate us on the app store!",
  removePhoto: "Remove photo",
  saveProfile: "Save Profile",
  searchMeals: "Search Meals",
  seatCharges: "Seat Charges",
  seatPremium: "A+",
  selectMeals: "Select meals",
  selectSeats: "Select Your Seat",
  sendETicket: "Send eTicket",
  serverError: "Our servers are down! please come after sometime",
  stationCode: [
    {
      _uid: "d6840285-6981-47fc-b4fc-fc616efe9b64",
      code: "BLR",
      aliases: "Bangalore, Bengaluru",
      component: "stationCodeCard"
    },
    {
      _uid: "5e9a81f7-9336-4cdd-8ea1-963b133847db",
      code: "COK",
      aliases: "Kochi, Cochin",
      component: "stationCodeCard"
    },
    {
      _uid: "76ced827-ce7c-4f5b-a885-a8270635f8ad",
      code: "AMD",
      aliases: "Ahmedabad, Amdavad",
      component: "stationCodeCard"
    },
    {
      _uid: "32fbe139-fb4c-4bab-aece-8d3f75748f41",
      code: "BOM",
      aliases: "Mumbai, Bombay",
      component: "stationCodeCard"
    }
  ],
  travelDates: "Travel Dates",
  tripUpdates: "Trip updates",
  undoCheckIn: "Undo Check-in",
  unsubscribe: "Unsubscribe",
  upgradeDesc: "Latest app is available. Please upgrade you app",
  valueCombos: "Value combos",
  viewBooking: "View Booking",
  viewETicket: "View eTicket",
  viewSummary: "View summary",
  BeforeFlying: "",
  addPromoCode: "Add promo code",
  adjacentSeat: "Adjacent seat",
  akasaPremium: "Akasa Premium Deal",
  beforeFlying: "before flying",
  boardingPass: "Boarding Pass",
  boardingTime: "Boarding time",
  boardingZone: "Boarding Zone",
  cancelFlight: "Cancel Flight",
  charsAllowed: "Only letters are allowed",
  chooseOrigin: "Choose Origin",
  clearLiteral: "Clear",
  confirmSeats: "Confirm Seat(s)",
  continueText: "Continue",
  dateOfTravel: "Date Of Travel",
  dobErrorText: "Please enter Date of Birth",
  earlyMorning: "Early Morning",
  extraBaggage: "Additional Bags",
  fareLockDesc: "If the price increases you still pay {}.",
  flightNumber: "Flight Number",
  foundFlights: "Found {} flights",
  genderFemale: "Female",
  iDeclareThat: "I declare that",
  imTravelling: "I'm travelling",
  indianRupees: "Indian Rupees",
  infantNumber: "Infant {}",
  infantPlural: {
    one: "1 Infant",
    two: "2 Infants",
    many: "{} Infants",
    zero: "No Infant",
    other: "{} Infants"
  },
  invalidEmail: "Please enter a valid email ID",
  invalidPhone: "Enter a valid phone no.",
  invalidQuery: "Invalid. Please raise a valid query.",
  justMoreBook: "just {} more when you book with",
  logInSuccess: "Sign in successful",
  memberShipNo: "Membership no.",
  membershipNo: "Membership no.",
  noAnnualFees: "No annual fees",
  notAvailable: "Not Available",
  offersForYou: "Akasa Deals",
  optionalText: "Optional",
  pnrTextField: "PNR/Booking Reference",
  pointsPlural: {
    one: "1 point",
    many: "{} points",
    zero: "No points",
    other: "{} points"
  },
  queryDetails: "Query Details",
  razorPayName: "Akasa Air",
  referAndEarn: "Refer and Earn",
  refundAmount: "Refund Amount",
  relationship: "Relationship",
  resetBooking: "Reset booking?",
  returnToHome: "Home",
  sampleHeader: "Sample header",
  seatOccupied: "Occupied",
  seatSelected: "Seat selected",
  selectAddONs: "Select Add-Ons",
  selectAddOns: "Select Add-Ons",
  skipAddOns: "Skip Add-ons",
  selectGender: "Select gender",
  specialFares: "Special fares",
  taxesAndFees: "Taxes & fees",
  trackBaggage: "Track baggage",
  upcomingTrip: "Upcoming Trip",
  upgradeTitle: "Upgrade available",
  userNotFound: "User not found",
  validphotoID: "Valid photo ID must be present at check-in.",
  webPromoCode: "TEST",
  AgencyDetails: "Agency Details",
  ChangeProfile: "Change Profile",
  PassengerName: "Passenger Name",
  accessibility: "Accessibility",
  addGSTDetails: "Add GST details",
  addGstDetails: "Add GST details",
  addNewProfile: "Add your GST details",
  addToCalender: "Add to Calendar",
  adultAgeGroup: "Age above 12",
  allPassengers: "All passenger(s)",
  bookingFailed: "Booking failed",
  bookingStatus: "Booking Status",
  businessEmail: "Business Email ID",
  busniessEmail: "Business email ID",
  cancelBooking: "Cancel Booking",
  cancelledDate: "Cancelled date",
  changeBooking: "Change booking",
  changeProfile: "Change profile",
  changeRequest: "change request",
  checkInClosed: "Check-in window closed",
  checkInFailed: "Check-in failed",
  cityOrAirport: "City/Airport",
  communication: "Communication",
  deleteAccount: "Delete Account",
  departureDate: "Departure date",
  departureTime: "Departure time",
  doctorsNurses: "Doctors & Nurses",
  earn150Points: "Earn 150 points on this trip",
  editTraveller: "Edit traveller",
  emailOrMobile: "Email or Mobile number",
  enterLastName: "Please enter last name",
  excessBaggage: "Excess Baggage",
  fareBreakdown: "Fare breakdown",
  fasterCheckin: "Faster Check-in",
  fastestFlight: "Fastest flight",
  forExtraSeats: "for extra seats",
  fourpmEightpm: "16:00-20:00",
  gSTDetailsMsg:
    "If you are travelling for business purposes or travelling commercially with the income of your business or your company, then you can fill in the company’s GST details to claim tax credit.",
  groupTypeData: [
    {
      _uid: "3ad5457a-4ad8-4320-b187-e11d5cc279e2",
      body: "Wedding",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "944a34f8-fcf3-48ab-a2d9-7f010442b896",
      body: "Corporate",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "06f0c138-710b-4672-bd63-610748c88cd2",
      body: "Events",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "9e8e769d-11a1-4eb9-a933-cc6ca56e296e",
      body: "Meeting",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "af88238c-7480-4a36-beac-f33c7b549271",
      body: "Conference/Convention",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "0dbb160c-bf30-4635-9a2c-8f53d3195acd",
      body: "Leisure Travel",
      component: "label",
      device_type: [],
      custom_style: []
    }
  ],
  invalidOtpMsg: "Either OTP is incorrect or expired",
  joinClubAkasa: "Join Club Akasa",
  loungeService: "Lounge ",
  manageBooking: "Manage",
  manageProfile: "Manage Profile",
  mealsSelected: "Meals selected",
  modifyBooking: "Modify Booking",
  myPreferences: "My preferences",
  noAddOnsFound: "No Add-Ons found",
  nonVegetarian: "Non-Vegetarian",
  numNotAllowed: "Numbers not allowed",
  numberOfStops: "Number of stops",
  ownWheelChair: "I'm bringing my own wheelchair/mobility device",
  payInCurrency: "",
  paymentFailed: "Payment failed",
  pleaseSpecify: "Please specify",
  popularCities: "Our destinations",
  preferredDate: "Preferred date",
  privacyCentre: "Privacy centre",
  refineResults: "Refine Results",
  removeProfile: "Remove Profile",
  saveOnReturns: "Save 10% on roundtrips",
  saveToProfile: "Save to profile",
  savedPayments: "Saved Payments",
  searchFlights: "Search Flights",
  seatAndAddons: "seat(s) and addons",
  seatAvailable: "Non-reclining",
  shareIternary: "Share Itinerary",
  signInWithOTP: "Sign In With OTP",
  signInWithOtp: "Sign In With OTP",
  signUpSuccess: "Sign up successful",
  sixamTwelvepm: "6:00-12:00",
  skipToPayment: "No, Skip to payments",
  twelveamSixam: "12:00-6:00",
  updateDetails: "Update Details",
  useOtpInstead: "Use OTP instead",
  usePwdInstead: "Use password instead",
  "viewETicket  ": "View eTicket",
  AgencyInvolved: "Agency Involved",
  ONEWAY_CHECKIN: "Your one way flight for",
  addAndContinue: "Add & Continue",
  baggageCheckIn: "Baggage Check-in",
  boardingPasses: "Boarding pass(s)",
  bookingChanged: "Booking Changed",
  bookingProcess: "Booking process",
  bookingSummary: "Booking summary",
  businessMobile: "Business Mobile Number",
  busniessMobile: "Business Mobile Number",
  changePassword: "Change password",
  checkInBaggage: "Check-in Baggage",
  checkInOpensIn: "Check-in opens in {} hours",
  checkInPending: "check-in-pending",
  checkinBagagge: "Checkin Bagagge(15Kg)",
  checkinBaggage: "Check-in Baggage",
  checkinProcess: "Check-in process",
  childrenPlural: {
    one: "1 Child",
    two: "2 Children",
    many: "{} Children",
    zero: "No Child",
    other: "{} Children"
  },
  chooseDocument: "Choose document",
  cityIsRequired: "Please select city",
  confirmBooking: "Fare locked. Confirm your booking",
  contactDetails: "Contact Details",
  convFeeTooltip:
    "A non-refundable convenience fee of ₹350 (inclusive of taxes, as applicable) is charged per segment, per passenger.",
  dangerousGoods: "Prohibited Items for air travel",
  daysToGoPlural: {
    one: "1 day to go",
    two: "2 days to go",
    many: "{} days to go",
    zero: "0 day to go",
    other: "{} days to go"
  },
  domesticFlight: "Domestic flight",
  downloadpdfTXT: "Download Pdf",
  earliestFlight: "Earliest flight",
  editGSTDetails: "Edit GST Details",
  editGstDetails: "Edit GST Details",
  enjoyYorFlight: "Enjoy the Akasa experience",
  enterAPassword: "Enter a Password",
  enterOtpSentTo: "Enter the OTP sent to",
  enterPNRNumber: "Please enter PNR number",
  enterYourEmail: "Enter your email address",
  exitSeatsTitle: "Exit/Emergency row seats",
  failedToUpdate: "",
  flamableLolids: "Flamable solids",
  flightDuration: "Flight duration",
  forgotPassword: "Forgot Password",
  gotSpecialCode: "Got a special code? Add it here for discounts",
  gstSubjectText: "GST Invoice",
  homePromoNudge: "Use code {} & get up to {}% off on your base fare*",
  infantAgeGroup: "7 days to 2 years. No seat",
  invalidAddress: "Invalid Address",
  invalidPinCode: "Invalid Pin Code",
  limbImpairment: "Limb impairment",
  makePaymentWeb: "Payment",
  makeSummaryWeb: "Summary",
  noBookingFound: "No booking found",
  noFlightsFound: "No flights found",
  oneClickSignin: "One-click sign-in will be enabled for these accounts",
  otpDescription: "Allow Akasa Air to read the message below and enter code?",
  paymentHeading: "Akasa Air",
  paymentSummary: "Payment summary",
  penaltyCharges: "Penalty Charges",
  pickYourAddOns: "Pick your Add-Ons",
  pnrFormatError: "PNR must have only uppercase alphabets and numbers, max 6",
  preBookInDelhi: "Pre-book your stay in Delhi",
  preferedTiming: "Prefered Timing",
  promoTextPart1: "Use code",
  promoTextPart2: "to get {}% off {}",
  sampleCheckbox: "Sample checkbox",
  savedCompanies: "Saved companies",
  savedTravelers: "Saved travellers",
  searchForMeals: "Search For Meals",
  selectDateText: "Select Date",
  seniorCitizens: "Senior Citizens",
  shareItinerary: "Share Itinerary",
  socialProfiles: "Social profiles",
  specialRequest: "Special request",
  speechImpaired: "Speech impaired",
  switchCurrency: "Switch currency",
  totalDeduction: "Total Deduction",
  twelvepmFourpm: "12:00-16:00",
  undoCheckInFor: "Undo Check-in for",
  upcomingFlight: "Upcoming flight",
  uploadNewPhoto: "Upload new photo",
  uploadPassport: "Upload Passport",
  viewGSTInvoice: "View GST invoice",
  whosTravelling: "Who’s travelling?",
  whostravelling: "Who’s travelling?",
  UndoCheckInIcon: "",
  addOnNudgeTitle: "Customise your booking?",
  addToFavourites: "Add to Favourites",
  akasaValueCombo: "Akasa Value Combo",
  autoAssignSeats: "Auto seat assign",
  businessEmailID: "Business Email ID",
  businessProfile: "Business profile",
  carouselBookNow: "Book Now",
  completeProfile: "Complete Profile",
  confirmPassword: "Confirm Password",
  continueAsGuest: "Continue as guest",
  createTraveller: "Create traveller",
  currentLocation: "Use current location",
  currentPassword: "Current password",
  customerSupport: [
    {
      _uid: "3b257420-bdc3-4604-843a-78418dc2eb90",
      label: "Customer Support Number",
      content: "",
      component: "labelWithContent",
      custom_style: []
    }
  ],
  downloadETicket: "Download eTicket",
  downloadInvoice: "Download Invoice",
  eightCharacters: "8 characters",
  eightpmTwelveam: "20:00-24:00",
  emailGSTInvoice: "Email GST invoice",
  emailOrLastName: "Email/Last Name",
  enterYourCities: "Enter your Cities",
  errInvalidPromo: "Invalid promo code",
  errPaxMandatory: "Please enter at least one passenger",
  failedToSendOtp: "Failed To Send Otp",
  feedbackSuccess: "Thank you for your feedback. We will get back to you shortly.",
  flamableLiquids: "Flamable liquids",
  genderErrorText: "Please select gender",
  hearingImpaired: "Hearing impaired",
  invalidFeedback: "Please enter a detailed description",
  invalidLastName: "Invalid last name",
  invalidPassword: "Enter Valid Password",
  myDocumentsDesc: "Keep your important documents handy by storing them in our secure vault",
  needaWheelChair: "Need a wheelchair",
  newGeneratedPnr: "New generated PNR",
  passengerNumber: "Passenger {}",
  paymentReceived: "Payment of {} received",
  photoWithCamera: "Photo With Camera",
  preferredCities: "Preferred cities",
  productDocument: "Product Document",
  removeTraveller: "Remove traveller",
  removethisaddon: "Remove this Add-On?",
  savedTravellers: "Saved travellers",
  searchForCities: "Search for cities",
  searchWithVoice: "Search with voice",
  seatPremiumPlus: "A++",
  selectGenderMsg: "Please Select gender",
  selectPassenger: "Select Passenger",
  sendToAnotherId: "Send to another ID",
  seniorCitizen_s: "Senior Citizen(s)",
  specialRequests: "Wheelchair assistance",
  ssrUnsellFailed: "Failed to remove special assistance",
  toxicSubstances: "Toxic substances",
  travelGuideline: "Check the latest travel guidelines",
  travelInsurance: "Travel Insurance",
  tripTypeWithPnr: "{tripType} PNR - {pnr}",
  visuallImpaired: "Visually impaired",
  webBoardingPass: "Web Boarding Pass",
  yourBaggageTags: "Your baggage tags",
  YourOnewayFlight: "Your one way flight",
  addExcessBaggage: "Add Excess Baggage",
  agreeAndContinue: "Agree & Continue",
  airportNearestTo: "Airport nearest to {}",
  akasaMobileOffer: " Book on AkasaAir.com or our mobile app for special deals and offers",
  akasaPhoneNumber: "+91 9606112131",
  alreadyCheckedIn: "Already check-in",
  baggageAllowance: "Baggage Allowance",
  bookingCancelled: "Booking Cancelled",
  cancelBookingMsg: "Are you sure you want to cancel the \nbooking?",
  cancelFlightXtoY: "Cancel Flight {}",
  changeBookingCta: "Change Date",
  changeOfAircraft: "Disembarking & change of aircraft is required during layover",
  childrenAgeGroup: "Age 2 to 12",
  confirmAndSignIn: "Confirm & Sign In",
  dateChangeCharge: "Date change charges",
  dayAfterTomorrow: "Day After Tomorrow",
  enterNewPassword: "Enter new password",
  estimatedArrival: "Estimated Arrival",
  favouriteFlights: "Favourite flights",
  flightDelayCover: "Flight delay cover",
  flightWithNumber: "Flight {}",
  iagreetopurchase: "I agree to purchase {}. I have read the product document and agree to the terms and conditions.",
  invalidFirstName: "Invalid first name",
  loggedOutMessage: "You have successfully logged out!",
  mealPlusNoteText: "Select complimentary meal for each flight(s) or passenger(s)",
  nameAtLeast2Char: "Name should be at least 2 characters",
  neverMissAnOffer: "Never miss an offer ",
  newsReleaseYears: [
    {
      _uid: "b73c1ced-707d-4297-abb3-eefe989cb10d",
      value: "2021",
      component: "number"
    },
    {
      _uid: "c495b852-4879-4c8a-b9b0-2d0c1b42f4f2",
      value: "2022",
      component: "number"
    },
    {
      _uid: "ebff0ef3-8abb-4453-8a1b-3fb5fce64806",
      value: "2023",
      component: "number"
    }
  ],
  noCountriesFound: "No countries found",
  noDocumentsAdded: "No documents added",
  noMedicalConerns: "I am able bodied, a above the age of 15 and have no medical conerns",
  noTravelersAdded: "No travellers added",
  nudgeWidgetTitle: "Sign in for a personalised experience",
  passengerDetails: "Passenger details",
  passengersPlural: {
    one: "1 Passenger",
    two: "2 Passengers",
    many: "{} Passengers",
    zero: "No Passenger",
    other: "{} Passengers"
  },
  paymentErrorText: "Your payment didn't go through.",
  pdfValidationMsg: "Please upload PDF files only, that are no larger than 3MB in size.",
  photoWithGallery: "Photo From Gallery",
  promoCodeApplied: "Promo code applied ({})",
  promoCodeRemoved: "Promo code removed. Either promo code or special fares can be applied at a time",
  rateYourTripText: "Rate your trip",
  scheduledArrival: "Scheduled Arrival",
  seatsAtthisPrice: "seats left at this price.",
  sendBoardingPass: "Send Boarding Pass",
  signInWithGoogle: "Sign in with Google",
  signUpBreezePast: "Sign-up to breeze past booking",
  ssrUnsellSuccess: "Special assistance removed",
  termsNConditions: "terms and conditions",
  travelGuidelines: "Travel Guidelines",
  viewBoardingPass: "View boarding pass",
  webPromoDiscount: "Plan your next travel with us",
  yourFareIsLocked: "Your fare is locked",
  yourUnusedPoints: "Here's where your 10000 unused points can take you",
  MULTICITY_CHECKIN: "Your multi city flights for",
  ROUNDTRIP_CHECKIN: "Your round trip flights for",
  addedToFavourites: "",
  akasaPremiumCombo: "Akasa Premium Deal",
  akasaValueContent: "Get A+ seat and a complimentary meal",
  alreadySubscribed: "Email already subscribed",
  atLeast1UpperCase: "Atleast one uppercase letter",
  bookingProcessing: "Your booking is under process",
  bookingSuccessful: "Booking is successful",
  bookingSummaryWeb: "Booking Summary",
  breezePastBooking: "Breeze Past Booking",
  etihadCheckInInfo: "You are trying to check-in for an Etihad Airways codeshare flight. Please contact Etihad Airways or visit the airport counter to complete your check-in.",
  importantInformation: "Important Information",
  charterBookBudget: [
    {
      _uid: "5dbd51ad-72be-4463-95d5-6a090384227b",
      body: "5lakhs",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "8e0716e7-a6f6-422b-98b9-fa676b52a67b",
      body: "10 lakhs",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "fbc7197e-2ecf-4d1a-b390-60ac24de6e03",
      body: "15 lakhs",
      component: "label",
      device_type: [],
      custom_style: []
    }
  ],
  checkInNotAllowed: "Check-in not allowed",
  checkInSuccessful: "Check-in successful!",
  chooseDateOfBirth: "Choose Date Of Birth",
  chooseDestination: "Choose Destination",
  departureTerminal: "Departure Terminal",
  domesticIntlTitle: "Travelling heavy?  Pre-book Excess Baggage",
  earn150PointsDesc: "You’re one step away from earning Earn 150 points on this trip with Club Akasa",
  emailPhoneNoBlank: "Email/Phone cannot be blank",
  enterFlightNumber: "Please enter flight number ",
  enterGstErrorText: "Please enter GST Number",
  errorDataNotFound: "Data not found",
  exploreMembership: "Explore membership",
  flightDetailsText: "Flight Details",
  invalidEmailPhone: "Invalid email or phone number",
  lastNameErrorText: "Please enter last name",
  managePreferences: "Manage Preferences",
  membershipUpdates: "Membership updates",
  myBookingPastText: "Past",
  myUpcomingFlights: "My Upcoming Flights ({})",
  noCurrenciesFound: "No currencies found",
  numberOfPassenger: "Number Of Passengers",
  paymentFailedDesc: "Looks like your payment did not go through.",
  promotionalOffers: "Akasa Deals",
  pushNotifications: "Push notifications",
  removeThisProfile: "Remove this profile?",
  restartToContinue: "Restart to continue",
  retrieveUsingAPNR: "Retrieve using a PNR",
  retrieveUsingAPnr: "Retrieve using a PNR",
  searchWidgetStrip: "Get 10% OFF on your first trip",
  searchWidgetTitle: "Book a Flight",
  selectAnotherDate: "Please select another date",
  selectBothFlights: "Please select both onward and return flights.",
  shareFlightDetail: "I am booked on Akasa Air. Follow me here: {}",
  shareFlightStatus: "Share flight status",
  shareReferralLink: "Share referral link",
  specialAssistance: "Special Assistance",
  stationIsRequired: "Please select station",
  trackFlightPrices: "Track flight prices",
  tripCompletedText: "Trip Completed",
  undoCheckInFailed: "Undo check-in failed",
  uploadNewPhotoMsg: "Please upload JPEGs or PNGs no larger than 1MB in size.",
  userAlreadyExists: "User already exists",
  wevegotyoucovered: "We’ve got you covered. {} added",
  whatAreGSTDetails: "What are GST details?",
  GSTInvoiceRequired: "GST Invoice required",
  PaymentSuccessText: "Payment Success",
  addBookingToMyTrip: "Add this booking to My Trip",
  addDescriptionText: "Add Description",
  addOnNudgeSubtitle: "Pick your seats, pre-order meals, booking excess baggage and much more",
  additionalServices: "Additional services",
  adultCountExceeded: "Adults cannot exceed ",
  adultPassengerType: "Adult",
  baggageInformation: "Baggage information",
  beboardingNotAllow: "Aircraft to be disembarked only at the final destination; deboarding during layover not allowed",
  ceckinopensinhours: "Check-in opens in hours",
  childPassengerType: "Child",
  completeYourSignUp: "Complete your sign up",
  complimentaryMeals: "Get a complimentary meal and extra legroom for just INR 500.",
  confirmNewPassword: "Confirm new password",
  confirmYourBooking: "Confirm your booking",
  destinationAddress: "Destination Address",
  destinationPinCode: "Destination Pincode",
  destinationPincode: "Destination Pincode",
  downloadGSTInvoice: "Download GST invoice",
  eTicketSubjectText: "eTicket",
  enhanceYourBooking: "Enhance your booking",
  errNoLocationFound: "Could not find your location",
  estimatedDeparture: "Estimated Departure",
  excessBaggageLimit: "Maximum of {} Kgs are allowed",
  excessBaggageTotal: "Excess baggage total",
  exploreWidgetTitle: "Not sure where to go? Explore",
  failedToAssignSeat: "Please select different seat",
  fareLockPriceNudge: "Please pay the fare amount of {} before {} by {} to confirm your booking",
  fareLockShortNudge: "Lock fare for {} until {} ",
  fetchHealthDetails: "Fetch health details",
  firstNameErrorText: "Please enter first name",
  flightAlreadyFlown: "Flown",
  generateAnotherOne: "Generate Another One",
  gstDetailsAddedFor: "Details added for",
  gstDetailsOptional: "GST Details (Optional)",
  gstNumberErrorText: "Please enter a valid GST number",
  iMustWearAFaceMask:
    "I must wear a face mask for the duration of the flight in accordance with Akasa protocols for the safety of all passengers",
  inAppNotifications: "In-app Notifications",
  inFlightExperience: "In-flight experience",
  minutesOfDeparture: "25 minutes prior to depature",
  miscDangerousGoods: "Misc dangerous goods",
  mobileBoardingPass: "Mobile Boarding Pass",
  mobilityAssistance: "Mobility",
  myBookingPNRNoText: "PNR No.",
  myBookingPnrNoText: "PNR No.",
  otherSignInOptions: "Other sign in options",
  paymentDescription: "Pay using Razorpay",
  peroxidesOxidisers: "Peroxides & oxidisers",
  retrieveWithoutPNR: "Retrieve without a PNR",
  retrieveWithoutPnr: "Retrieve without a PNR",
  savedTravelersDesc: "Add people to your list of saved travellers to quickly add them when you book your next flight",
  scheduledDeparture: "Scheduled Departure",
  sendBoardingPassId: "Send all boarding pass(s) to this ID",
  seniorCitizenShort: "SC",
  signInForPersonali: "Sign in for a \npersonalised experience",
  signInWithFacebook: "Sign in with Facebook",
  signInWithPassword: "Sign in with password",
  somethingWentWrong: "Something went wrong. Please try again later.",
  specialOfferForDob: "Enjoy Akasa Deals on your birthday month",
  tryADifferentRoute: "Try a different date",
  undoCheckInSuccess: "Undo check-in is successful ",
  uploadPhotoSizeMsg: "Please upload JPEGs or PNGs no larger than 1MB in size.",
  walkingUsingStairs: "Need help while walking/using stairs",
  addPassengerDetails: "Add details of all passengers",
  akasaPremiumContent: "Get a premium seat, meal, priority check-in and more",
  allForAllPassengers: "Add for all\npassengers",
  bookAgainButtonText: "Book",
  bookingOnHoldAndPnr: "Your PNR {}",
  businessProfileDesc: "Please provide your GST details",
  buttonLiteralSelect: "Select",
  cancellationCharges: "Cancellation charges",
  checkInAccessButton: "Check-in",
  checkInForCityCodes: "Check-in for {}",
  checkInWindowClosed: "Check-in window has closed",
  chooseDepartureDate: "Choose a departure date",
  cognitiveDisability: "Cognitive disability - limitations in communication, self-help, and social skills",
  corrosiveSubstances: "Corrosive substances",
  dateOfBirthOptional: "Date Of Birth (Optional)",
  editBusinessProfile: "Edit business profile",
  emailIdMobileNumber: "Email ID/Mobile Number",
  enterEmailErrorText: "Please enter email address",
  fareLockedAmountMsg:
    "You locked this fare for {} on {}. Please pay the fare amount of {} before {} by {} to confirm your booking.",
  infantCountExceeded: "Infant cannot exceed ",
  infantPassengerType: "Infant",
  invalidFlightNumber: "Please enter valid flight number",
  invalidMobileNumber: "Invalid Mobile Number",
  invoiceNotGenerated:
    "Your GST invoice has not been generated yet, please check back at a later date or contact the 24/7 Akasa Care Centre on +91 9606 112131 for further support",
  isThisABusinessTrip: "Is this a business trip?",
  languagePreferences: "Language",
  layoverTimeWithCity: "{duration} layover in {city}",
  newPnrGenerationMsg: "New PNR will be generated for selected passengers after flight cancellation.",
  noMealSelectedError: "Please select a meal",
  paneertikkasandwich: "1 x Paneer Tikka Sandwich",
  passwordsDoNotMatch: "Passwords do not match",
  pleaseSelectSeatFor: "Please select seat for",
  radioctiveMaterials: "Radioactive materials",
  razorPayDescription: "Pay using Razorpay",
  removeAddonsMassage: "Are you sure you want to remove {}? You’ll miss out on some great benefits",
  removeThisTraveller: "Remove this traveller?",
  removeTravellerDesc:
    "Are you sure you want to remove {}? Their name will not appear in your list of saved travellers when you book your next flight.",
  retrieveABookingTxt: "Retrieve a Booking",
  saveCapitalisedText: "Save",
  selectAddonsStepper: "Select Add-Ons",
  selectYourFlightFor: "Select your flight for {} - {}",
  seniorCitizenPlural: {
    one: "1 Senior Citizen",
    two: "2 Senior Citizens",
    many: "{} Senior Citizens",
    zero: "No Senior Citizen",
    other: "{} Senior Citizens"
  },
  seniortCitizenShort: "SC",
  arrivingFrom: "Arriving from",
  expectedArrival : "Expected arrival",
  incomingAircraftStatus : "Incoming aircraft status",
  status : "Status",
  aircraftSubjectOperationalReason:"Aircraft subject to change for operational reasons.",
  aircraft: "Aircraft",
  AircraftType: "• Airbus A320 Neo | ",
  setPasswordAndLogin: "Set Password & Login",
  specialFaresRemoved: "special fares removed. Either promo code or special fares can be applied at a time",
  theFollowingFlights: "the following flights",
  thisIsaBusinessTrip: "This is a business trip",
  timelyNotifications: "Timely Notifications",
  unableChangeBooking: "unable to change booking for the choice right now",
  updateHealthDetails: "Update health details",
  updatedSuccessfully: "Updated Successfully",
  yourUpcomingFlights: "Your upcoming flights",
  GetUpdatesOnWhatsapp: "Get updates on Whatsapp",
  addMoreToBookingText: "Add more to your booking",
  addOnIncludedMessage: "",
  agreeToPurchaseAddon:
    "I agree to purchase {}. I have read the product document and agree to the terms and conditions.",
  allowedEquipmentType: ["7MA", "7MZ"],
  browserNotifications: "Browser Notifications",
  businessMobileNumber: "Business mobile number",
  cannotProceedFurther: "Cannot proceed further",
  charsAndSpaceAllowed: "Only letters and single space are allowed",
  charterBookingSector: [
    {
      _uid: "71591a01-736f-4f98-83fd-8676749604a6",
      body: "sector 1",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "07c6b971-ef88-4027-b4e7-cf1bb66b8b94",
      body: "Sector 2",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "f76e99a7-25ee-46ab-bb98-49946bf09409",
      body: "Sector 3",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "37ce6eb6-bae8-424e-9844-747d1d11ee29",
      body: "Sector 4",
      component: "label",
      device_type: [],
      custom_style: []
    }
  ],
  charterNoOfPassenger: [
    {
      _uid: "962665b4-ca8b-47c7-8a1a-ea5e5df0bf5f",
      body: "50",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "af5cef99-9049-467d-9205-73c232468916",
      body: "100",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "2c512b63-3c9d-4a92-81a6-bb31f810e2f5",
      body: "150",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "5ff58e10-dc73-46c5-ad23-e7c6d4990962",
      body: "200",
      component: "label",
      device_type: [],
      custom_style: []
    }
  ],
  convenienceFeeAmount: "350",
  deBoardingNotAllowed:
    "Aircraft to be disembarked only at the final destination; deboarding during layover not allowed",
  eTicketMailedSuccess: "eTicket mailed successfully",
  enterEmailOrLastName: "Please enter email/ last name",
  errorOperationFailed: "Operation failed",
  flightStopOverAtText: "at",
  infantDisclaimerText: "Infants will be seated on lap. They wont be assigned a separate seat.",
  invalidEmailOrMobile: "Email or Mobile number is invalid",
  mealsIncludeBeverage: "All meals include a beverage to be selected on-board our flight",
  minFlightSelectError: "Please select at least one flight from the list!",
  noFlightDetailsFound: "No Flight Details Found",
  passwordResetSuccess: "Password has been reset",
  passwordsDidNotMatch: "Passwords did not match",
  paymentProcessingMsg: "You payment is processing",
  retrieveABookingText: "Retrieve  Booking",
  retrieveBookingError: "Please enter the correct information.",
  seatSelectionStepper: "Select Your Seat",
  setUpBusinessProfile: "Set up business profile",
  unsubscriptionFailed: "Failed to unsubscribe",
  updateContactDetails: "Update contact details",
  yourMultiCityFlights: "Your multicity flights",
  addBirthDateTitleText: "Celebrate your special day with us",
  addMoreToXBookingText: "Add more to your {} booking",
  addNewBusinessProfile: "Add your GST details",
  allBookingRelatedInfo: "All booking related communication will be sent here",
  allFieldsAreMandatory: "All fields are mandatory",
  autoAssignSeatsFailed: "Auto assign seats failed",
  charterPreferedTiming: [
    {
      _uid: "1995364c-93cc-436e-a859-ced3476e707c",
      body: "12PM",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "8898fa0d-b3a6-4f7f-8442-4ba29e5f9c3f",
      body: "12AM",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "ba85d864-7589-4233-bd85-1be23968244f",
      body: "9PM",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "602c9054-d7fd-4dd7-83ab-322072b79191",
      body: "9AM",
      component: "label",
      device_type: [],
      custom_style: []
    }
  ],
  childrenCountExceeded: "Children cannot exceed ",
  enterYourFlightNumber: "Enter Your Flight Number",
  faceIdForFasterSignIn: "Use face ID for faster sign-in",
  failedToChangeBooking: "Failed to change booking",
  fileSizeValidationMsg: "File Size should not be greater than {} MB",
  flexibleDatesPossible: "Flexible date possible?",
  flightsOverlappingTxt: "Flights are overlapping. Please select another flight.",
  followUsOnSocialMedia: "Follow us on social media",
  iAmNotUnderQuarantine: "I am not under quarantine",
  impairmentsAssistance: "Impairments",
  letsSecureYourAccount: "Lets secure your account",
  myBookingUpcomingText: "Upcoming",
  nudgeWidgetButtonText: "Sign up now",
  paymentFailedTryAgain: "Payment Failed, please try again..",
  paymentProcessingDesc:
    "Please be assured you will receive confirmation within 15 minutes or your money will be refunded",
  pnrOrBookingReference: "PNR/Booking Reference",
  primaryContactDetails: "Primary contact details",
  recentStationSearches: "Recent Searches",
  registeredCompanyName: "Company Name",
  removeBusinessProfile: "Remove this business profile?",
  requestSuccessMessage: "Your request has been registered with us, we will get back to you shortly.",
  selectBusinessProfile: "Select business profile",
  selectOptionErrorText: "Please select an option",
  selectRelationshipMsg: "Please select relationship",
  seniorCitizenAgeGroup: "Age 60 and above",
  sessionExpiredMessage: "Session expired, please start again",
  stationCodeIsRequired: "Station code is required",
  unableToLoadThisAddOn: "Unable to load this add on at this moment",
  YourRoundTripFlightFor: "Your round trip flight for {}",
  addBirthDateButtonText: "Add birthdate",
  addedMoreToYourBooking: "Added more to your booking",
  additionalBaggageLimit: "Maximum of {} hand baggage is allowed",
  boardingPassEmailError: "Unable to send email",
  boardingPassMailedDesc: "Your boarding pass(s) will be mailed to the below email address",
  bookingConfirmedAndPnr: "Booking confirmed • PNR {}",
  charterBookingCategory: [
    {
      _uid: "e619bfef-b9ed-4828-917c-ecb9e75e2e82",
      body: "Category 1",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "6dde942e-1e45-4474-b62c-c0122648131b",
      body: "Category 2",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "234aa84f-fc51-4e2c-87ba-bbb3bb266893",
      body: "Category 3",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "13f84961-ba16-4f8d-9a1f-4474ef53df2d",
      body: "Category 4",
      component: "label",
      device_type: [],
      custom_style: []
    }
  ],
  checkInWindowYetToOpen: "Check-in window yet to open ",
  checkingMoreThanOneBag: "Checking in more than one bag? Add additional bags",
  chooseFlexiMealMessage:
    "Please select your free meal from the options below. You can select your free beverage onboard our flight.",
  conditionsBeforeYouFly: "Conditions before you fly",
  enterValidFlightNumber: "Please enter valid flight number",
  errPromoPlusSpecialPax: "Special fare and promo code cannot be availed together",
  errorDateFormatInvalid: "Date format is invalid",
  failedToMailGSTInvoice:
    "We are unable to email your GST invoice, for further assistance please contact the 24/7 Akasa Care Centre on +91 9606 112131.",
  failedToViewGSTInvoice: "Failed to view the invoice. Please try again later.",
  genderPreferNotToShare: "Prefer not to share",
  getAPremiumSeatAndMeal: "Get a Premium Seat and Meal",
  looksLikeYouAreOffline: "Looks like you’re offline",
  marketingCommunication: "Marketing communication",
  myBookingsAccessButton: "Manage",
  nameOfTheContactPerson: "Name of the Contact Person",
  noOfForeignNationality: "No of Foreign Nationality",
  notifyMeWhenPriceDrops: "Notify me when price drops",
  paymentUnderReviewText: "Looks like your payment is still under review.",
  pleaseEnterCorrectInfo: "Please +6",
  registeredEmailAddress: "Company Email Address",
  resetBookingDisclaimer: "Are you sure you want to reset current information and start afresh?",
  searchPanelPlaceholder: "Search For City/Airport",
  seatSelectionErrorText: "Please select Seat",
  selectYourOnwardFlight: "Select your onward flight",
  selectYourReturnFlight: "Select your return flight",
  specialCharsNotAllowed: "Special characters not allowed",
  spendPointsAtOurRetail: "Spend points at our retail partners",
  termAndConditionsApply: "Terms and conditions apply.",
  tncMissingSelectionMsg: "Please accept terms and conditions",
  vaccinationCertificate: "Vaccination certificate",
  viewCancellationPolicy: "View cancellation policy",
  yourFlightForCityCodes: "Your flight for {}",
  addDescriptionErrorText: "Please add a description",
  boardingPassSubjectText: "Boarding Pass",
  bundlePricePerPassenger: "{} per passenger",
  canContainOnlyAlphabets: "Can contain only alphabets",
  carouselTransitionDelay: "5000",
  checkInWindowClosedFull: "The check-in window for your flight\nhas closed",
  enableAccessibilityMode: "Enable accessibility mode",
  errInvalidAirportSearch: "Please enter a valid airport/city name",
  errNoNearbyAirportFound: "No nearby airport found",
  errorDuplicatedataexist: "Duplicate data exists",
  exitSeatAllocationError: "This seat is allowed for adult only",
  exploreWidgetButtonText: "View all",
  getNotifiedPricesChange: "Get notified when prices change for all",
  gstInvoiceMailedSuccess: "GST invoice has been emailed to your registered email address",
  invalidLoginCredentials: "Invalid email/mobile or password",
  loggedOutFailureMessage: "Something went wrong, could not logout!",
  maintenanceAboutToStart: "Maintenance is about to start in {}.",
  makeSureYourPasswordHas: "Make sure your password has",
  manageBookingButtonText: "Manage Booking",
  noBoardingPassAvailable: "No boarding pass available",
  notRequireExtensionBelt: "I do not require an extension belt",
  notifyMeAboutPromotions: "Notify me about promotions",
  otherAssistanceRequired: "Other assistance required",
  preBookMealLimitForTime: "Note : Meals can be pre-booked up to 12 hrs prior to flight departure",
  recentSearchesTitleText: "Your recent searches",
  selectSameAddressForAll: "Select same address for all",
  signUpForFasterCheckout: "Sign up for faster checkout",
  signUpTermsAndCondition: [
    {
      _uid: "060610c7-5790-4276-936f-41c13b599170",
      tncText: "Terms of Use",
      TnC_link: {
        id: "602ec03c-4149-42f1-abb7-e195849c044a",
        url: "",
        linktype: "story",
        fieldtype: "multilink",
        cached_url: "/en/quick-links/terms-and-conditions",
        prep: true
      },
      bodyText: "By continuing, I agree to the {tnc_text} and {privacy_policy_text}",
      component: "signUpTermsAndConditionLable",
      linkColor: "#614ab6",
      privacy_policy_link: {
        id: "166ca3b3-0e18-4f5f-a415-a213413d77a3",
        url: "",
        linktype: "story",
        fieldtype: "multilink",
        cached_url: "/en/quick-links/privacy-policy",
        prep: true
      },
      privacy_policy_text: "Privacy Policy"
    }
  ],
  subscribeNewsLetterDesc: "Subscribe and be the first to receive Akasa updates",
  termsandconditionsapply: "*Terms and conditions apply.",
  unmnrSpecialDescription:
    "Children between the ages of 5 and under 12 years who will be traveling alone are considered unaccompanied minors. A booking fee will be applicable each way per unaccompanied minor. Once booked, please fill the Unaccompanied Minor form available on our website. Print 4 copies of the same and bring them with you to the airport.",
  updatePreferencesFailed: "Failed to update preferences",
  yourFlightsUnderthisPNR: "Your flights under this PNR",
  addBirthDateSubTitleText: "Enjoy Akasa Deals on your birthday month",
  boardingPassEmailSuccess: "Boarding pass successfully sent",
  bookAgainWidgetTitleText: "Book again",
  bookingAddedSuccessfully: "Booking Added successfully",
  carouselTransitionTiming: "1000",
  checkInAutoAssignedSeats: "Check-in through auto assigned seats",
  copyOfYourBookingRelated: "A copy of your booking related info will be sent to ",
  currentBookingStateError: "current state in booking failed",
  doNotCarryDangerousGoods:
    "Do not carry dangerous goods in your baggage or on your person. For any clarification with regards to dangerous goods, contact our Akasa Care Centre.",
  fareLockedPaymentpending: "Fare locked. Payment pending",
  flightStatusAccessButton: "Flight Status",
  flightSummaryOneWayTitle: "Your one way flight summary for {}",
  gateIsSubjectToChangeMsg: "Gate is subject to change and will close {} prior to departure.",
  iWantToReadTheConditions: "I want to read the conditions",
  lowestFairOnOtherAirline: "Lowest fair available on other airline is",
  manageBookingETicketText: "E-Ticket",
  myUpcomingFlightsLiteral: "My Upcoming Flights",
  notTestedCOVID19Positive: "I have not tested COVID-19 positive in the last three weeks",
  nudgeWidgetTitleLoggedIn: "Earn points on every booking with Club Akasa",
  openTheExitInanEmergency:
    "I understand the exit weighs 15 kgs and I am willing to open the exit in an emergency when adivsed by crew",
  removeBusinessProfileMsg: "This will delete the profile, are you sure?",
  sportMusicEquipmentLimit: "Maximum of {} Sports/Music Equipment  is allowed",
  unsubscriptionSuccessful: "You have unsubscribed",
  weAreGoingForMaintenance: "We are going for maintenance",
  CharterAdditionalServices: [
    {
      _uid: "07b8a975-9eab-43b5-891b-1af31c384806",
      body: "Food",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "9790b54e-dc25-4cd5-ba1c-c55b788b1613",
      body: "Customer Service",
      component: "label",
      device_type: [],
      custom_style: []
    }
  ],
  boardingPassMailedSuccess: "Boarding pass mailed successfully",
  cancelBookingNotAvailable: "Sorry cancel booking not available for this booking",
  changeBookingNotAvailable: "Sorry change booking is not available.",
  charterNoOfForeignNations: [
    {
      _uid: "36e49355-33ac-4653-bfe1-6ba62cdefaaa",
      body: "1",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "a0995559-2149-4c94-a082-099d5c2dd276",
      body: "2",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "35789b21-4821-40d0-b2ad-01d560af8ace",
      body: "3",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "8d18d598-1ba9-44c1-8ae7-e681fa4acf2d",
      body: "4",
      component: "label",
      device_type: [],
      custom_style: []
    }
  ],
  coverApplicableBelowAge70: "{} is applicable only for Indian citizens below the age of 70 years",
  dangerousGoodsAndArticles: "Prohibited or Restricted Articles for air travel",
  enterMobileOrEmailToReset: "Please enter your email ID. We’ll send you an OTP for you to reset your password.",
  getEmailUpdatesForBooking: "Get email updates for booking",
  groupBookingMaxAdultCount: "1000",
  groupBookingMinAdultCount: "10",
  iHaveReadAndUnderstoodAll: "I have read and understood all the important security information.",
  inEligibleForGroupBooking: "At least 10 passengers required",
  invalidUserNameOrPassword: "Invalid username or password.",
  marketingCommunicationMsg:
    "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.",
  onlineCheckInOpens48Hours: "Online check-in opens 48 hours prior to departure.",
  passwordHaveAtLeast8Chars: "Make sure the password has at least 8 characters",
  pleaseAddPassengerDetails: "Please add passenger details",
  popupOptionsCancelBooking: "Cancel booking",
  popupOptionsChangeBooking: "Change booking",
  postUnsubscriptionMessage: "Unsubscribe successful",
  requiresSpecialAssistance: "Wheelchair assistance",
  rootedDeviceDetectedTitle: "App not supported",
  searchWidgetStripLoggedIn: "Book your return flight to Bengaluru",
  stricklyNeccessarycookies: "Strictly necessary cookies",
  studentSpecialDescription:
    "Applicable for all students above the age of 12 years studying with a bonafide school/university. Valid photo ID and educational institute ID card need to be presented for verification at check-in. Bookings under this offer are refundable. Limited inventory available. This discount cannot be combined with any other offer. Terms & Conditions apply",
  subscriptionSuccessfulMsg: "Subscription Successful",
  unableToCancelThisBooking: "Unable to cancel this booking ",
  undoCheckInOtpSentMessage: "An OTP has been sent to your registered mobile number please verify it below",
  whenYouBookYourNextFlight: "when you book your next flight",
  allBookingRelatedUpdateMsg: "All your booking related updates will be sent to your number.",
  arrivalDateBeforeDeparture: "Arrival date should be after departure date",
  checkInWindowYetToOpenFull: "We are equally excited as you are. Your first Flight is just around the corner.",
  earnPointsWithEveryBooking: "Earn points with every booking",
  editProfileDetailsToastMsg: "Details updated sucessfully",
  eligibleToTravelAsPerNorms: "I am eligible to travel as per the extant norms",
  enterMobileNumberErrorText: "Please enter mobile number",
  getEmailUpdatesForBookings: "Get email updates for bookings",
  groupBookingMaxInfantCount: "200",
  groupBookingMinInfantCount: "0",
  makeSureYourNewPasswordHas: "Make sure your new password has",
  moneyWillBeRefundedMessage: "Your money will be refunded",
  notResidingContainmentZone: "I am not residing in nay containment Zone",
  onlyOneCheckInBagIsAllowed: "Only one check-in bag is allowed at no cost. Add additional bags starting at ₹750",
  passwordHaveAtLeast1Number: "Make sure the password has at least 1 number",
  paymentFailedPayWithinNext: "Please pay the due amount within the next {} to confirm your booking",
  paymentResolutionAssurance: "Please be assured that - Either you will recieve a confirmed PNR within 15 minutes",
  promoCodeAppliedWithNoArgs: "Promo code applied!",
  selectSeatforAllPassengers: "for all the passengers",
  sendBookingToBusinessEmail: "A copy of booking related info will be sent to your work inbox",
  sendETicketToBusinessEmail:
    "A copy of your booking eTicket will be sent to your business email ID. GST invoices will be sent to your business email ID within one month",
  sendETicketToBusniessEmail:
    "A copy of your booking eTicket will be sent to your business email ID. GST invoices will be sent to your business email ID within one month.",
  seniorCitizenCountExceeded: "Senior Citizen cannot exceed ",
  seniorCitizenPassengerType: "Senior Citizen",
  specialRequestSubmitFailed: "Failed to save special request",
  transactionReferenceNumber: "",
  "unableToCancelThisBooking ": "Unable to cancel this booking ",
  autoSeatCheckInSuccessTitle: "Check-in Requested!",
  cannotRemoveSoldBundleTitle: "Cannot remove",
  charterBookingAgencyDetails: [
    {
      _uid: "4a9b0839-e8d8-43db-9624-b3ede0d125b6",
      body: "Agency 1",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "82ffbf7c-ead9-4bbf-94c0-2fc3ca54987f",
      body: "Agency 2",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "839645ae-3536-4bb5-a9a2-f60a76b207aa",
      body: "Agency 3",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "46370383-86d6-44fc-9734-4d542ed80fc4",
      body: "Agency 4",
      component: "label",
      device_type: [],
      custom_style: []
    }
  ],
  checkInAgainAfterAWhileText:
    "Please try Check-in again after 15 minutes or kindly contact customer support at +91 9606 11 21 31 for further assistance.",
  checkInIsNotyetCompleteText: "Your Check-in is not yet complete.",
  communicationInHindiEnglish: "I understand communication in Hindi & English",
  datesChosenConflictingOrder: "Dates are chosen in conflicting order",
  flightSummaryMultiCityTitle: "Your multicity flight summary ",
  flightSummaryRoundTripTitle: "Your round trip from {}",
  healthAndContactDeclaration: "Health & contact declaration",
  infantCountExceedAdultCount: "No of infants cannot exceed no of adults",
  noFlightDelayCoverAvailable: "No flight delay cover available",
  passwordChangedSuccessFully: "Password changed successfully",
  passwordChangedSuccessfully: "Password changed successfully",
  paymentProcessingBookingMsg: "You payment is processing",
  profilePhotoRemovedToastMsg: "Profile photo removed sucessfully",
  profilePicRemovalSuccessful: "Profile picture removed",
  retrieveYourBookingUsingPNR: "Retrieve your booking using PNR",
  retrieveYourBookingUsingPnr: "Retrieve your booking using PNR",
  selectYourComplementaryMeal: "Select your complimentary meal",
  serverMaintenanceRestartMsg: "Server under maintenance.Please restart the app to continue",
  shareYourReferralCodeOrLink:
    "Share your referral code or link to invite friends and get ₹2000 off on your next booking. Get an additional ₹750 when they book their first flight",
  specialRequestSubmitSuccess: "Special request saved successfully ",
  updatePreferencesSuccessful: "Preferences updated successfully",
  youHaveSuccessfullySelected: "You have successfully selected your {}!",
  baggageCheckedInErrorMessage: "You can't proceed to undo checkin because you have checked in your baggage already.",
  boardingPassGateNotAllocated: "--",
  bundleApplicableForPassenger: "This combo is applicable for all passengers",
  businessProfileAddedToastMsg: "Business profile added sucessfully",
  changeBookingDatePickerError: "Please choose your preferred date(s) first!",
  charterBookingAgencyInvolved: [
    {
      _uid: "bb6dd1e9-1f58-4642-b4bc-00c2a2fdf38c",
      body: "Agency 1",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "9666e5d5-9006-4efe-ac92-0c6b9dc04311",
      body: "Agency 2",
      component: "label",
      device_type: [],
      custom_style: []
    },
    {
      _uid: "db2ce6d4-ae06-4ffe-b963-88cec02a9d47",
      body: "Agency 3",
      component: "label",
      device_type: [],
      custom_style: []
    }
  ],
  completePaymentByDateAndTime: "Complete payment by {}, {}",
  fareLockPaymentWindowExpired: "Fare lock payment window expired",
  groupBookingMaxChildrenCount: "200",
  groupBookingMinChildrenCount: "0",
  iDoNotHaveAnyProhibitedItems: "I Don’t have any prohibited items in my baggage",
  myBookingPopupOptionsCheckIn: "Check-in",
  myBookingPopupOptionsCheckin: "Check-in",
  profilePicUpdationSuccessful: "Profile pic added successfully",
  stricklyNeccessarycookiesMsg:
    "These cookies are essential in order to enable you to move around the site and use its features, such as accessing secure areas of the site. Without these cookies, services you have asked for cannot be provided",
  travelGuidelineWithCityCodes: "Check the latest travel guidelines for {}",
  userProfileEditionSuccessful: "Details updated successfully ",
  wouldyouliketochangeyourseat: "Would you like to change your seat(s)?",
  youAreRestrictedTowebcheckin: "You are restricted to web check-in",
  yourXBookingForYisSuccessful: "Your {} booking for {} is successful",
  addInformationForAllPassenger: "Add information for all passenger ",
  armedForcesSpecialDescription:
    "Applicable for all serving and retired Indian Armed Forces personnel, Paramilitary Forces personnel and their dependent families. Limited inventory available. Valid photo ID and relevant military card need to be presented for verification at check-in. This discount cannot be combined with any other offer. Terms & Conditions apply.",
  bookingRelatedUpdatesWhatsapp: "All your booking related updates will be sent to your number ",
  cancellationDateChangeCharges: "Cancellation & date change charges",
  cannotRemoveSoldBundleMessage: "Combo once sold cannot be removed",
  choosePassengersForWheelChair: "Choose the passenger(s) needing wheelchair assistance   ",
  complementaryMealLimitForTime: "Note : Meals can be pre-booked up to 12 hrs prior to flight departure",
  contactCustomerSupportMessage: "You could contact customer support for more information",
  errOriginDestinationMandatory: "Please enter at least one origin and destination",
  friendsFareSpecialDescription:
    "Family and Friends discount is applicable for a minimum of 4 passengers and a maximum of 9 passengers (excluding infant) on a single booking. This discount cannot be combined with any other offer. Terms & Conditions apply",
  gatewillclosepriortodeparture: "Gate is subject to change and will close 25 minutes prior to departure",
  howYouWouldLikeUsToContactYou: "Tell us how you would like us to contact you",
  iHaveAllTheNecessaryTravelDoc: "I have all the necessary travel documents needed for this itinerary and i understand",
  internationalConnectingFlight: "International connecting flight",
  invalidGstCompanyNameErrorMsg: "Please enter a valid GST name",
  nudgeWidgetButtonTextLoggedIn: "Join the club",
  onlineCheckInCommonDisclaimer:
    "For any clarification with regards to dangerous goods, contact our Akasa Care Centre.",
  passwordHaveAtLeast1Uppercase: "Make sure the password has at least 1 Uppercase letter",
  postUnsubscriptionDescription: "You will no longer receive any emails",
  profilePicRemovalUnsuccessful: "Failed to remove profile picture",
  retrieveYourBookingWithoutPnr: "Retrieve your booking without a PNR using the details below",
  travellerNameNotAppearListMsg: "Their name will not appear in your list of",
  unableToCancelBookingRightNow: "Unable to cancel booking right now",
  updateAlternateContactDetails: "Update alternate contact details",
  updateContactDetailsinProfile: "Update contact details in my profile. This will replace your existing details.",
  youCanRestartTheAppToContinue: "You can restart to continue using the app",
  yourInFlightTravelPreferences: "Your in-flight and travel preferences",
  businessProfileUpdatedToastMsg: "Business profile updated sucessfully",
  customizeBundleFareAddOnsTitle: "Select your complimentary meal",
  howWouldYouPreferToBeContacted: "How would you prefer to be contacted?",
  iWillAdhereStateUnionTerritory:
    "I will adhere to the health protocol prescribed by the destination state/union territory",
  ifThePriceIncreasesYouStillPay: "If the price increases you still pay ",
  onlySequentialCheckInIsAllowed: "Only sequential check-in is allowed. You cannot check-in out of order.",
  profilePicUpdationUnsuccessful: "Failed to add profile picture",
  spendPointsAtOurRetailPartners: "Spend points at our retail partners",
  undoCheckInConfirmationMessage: "Are you sure you want to undo check-in for this PNR/Booking ",
  userProfileEditionUnsuccessful: "Failed to update profile ",
  addNewBusinessProfileSuccessful: "New business profile added! ",
  boardingPassAutoSeatsPaxMessage: "Boarding pass will be emailed within 6 hours before departure. ",
  bookFlightsToSeeExistingBooking: "Book flights to see them here or retrieve an existing booking",
  checkInThroughAutoAssignedSeats: "Check-in through auto assigned seats",
  deleteAccountFailureSnackBarMsg: "Failed to delete user account",
  deleteAccountSuccessSnackBarMsg: "Successfully deleted the account",
  errorEmailIdExistWithAnotherAcc: "Email ID exists with another account",
  familyFriendsSpecialDescription:
    "Family and Friends discount is applicable for a minimum of 4 passengers and a maximum of 9 passengers (excluding infant) on a single booking. This discount cannot be combined with any other offer. Terms & Conditions apply",
  manageBookingPaymentFailureDesc:
    "Please wait for 15 minutes and check if has gone through You can contact customer support at +91 9606 11 21 31 for further assistance.",
  noRefundSeatChangeOnTheAircraft:
    "I accept to change my seat on the aircraft as provided by the crew, if I refuse to accept opening the exit during the crew briefing or if I do not adhere to the requirements of the seating row criteria as specified by the crew. (No refund for seat change on the aircraft)",
  notSufferingRespiratoryDistress: "I am not suffering from any fever, cough or any respiratory distress",
  otpSentToRegisteredMobileNumber: "",
  popupOptionsCancelFlightBooking: "Cancel flight",
  removeBusinessProfileSuccessful: "Business profile removed",
  rootedDeviceDetectedDescription: "App not supported in a device that is {} or in developer mode",
  seniorCitizenSpecialDescription:
    "The Senior Citizens' discount is applicable to passengers above the age of 60 years only. To travel using this fare, the passenger must present a valid age proof at the Akasa Air Check-in counter at the airport. This discount cannot be combined with any other offer. Terms & Conditions apply.",
  serverMaintenanceRestrictionMsg: "Server under maintenance. Please come back after some time.",
  unaccompaniedMinorPassengerType: "Unaccompanied Minor",
  updateBusinessProfileSuccessful: "Business profile updated!",
  invalidPnrAndLastNamePleaseCheck: "Invalid PNR and lastName please check.",
  retrieveYourBookingUsingMobileNo: "Retrieve using Mobile Number",
  selectedTheEmergencyExitRowseats:
    "I have selected the emergency exit row seats with extra legroom and I understand/concur the following instructions",
  signUpForAPersonalisedExperience: "Sign up for a personalised experience",
  undoCheckInBeforeFlightDeparture: "Undo check-in can be done before {} minutes of flight departure",
  yourMultiCityBookingIsSuccessful: "Your multicity booking is successful",
  yourTransactionReferenceNumberIs: "Your transaction reference number is \n",
  attemptLimitExceededTryAgainLater: "Attempt limit exceeded, please try after some time.",
  autoSeatCheckInSuccessDescription: "Your check-in request has been successfully submitted",
  groupBookingMaxSeniorCitizenCount: "200",
  groupBookingMinSeniorCitizenCount: "0",
  setupbusinessAccounttoRecieveCopy: "Please provide your GST details",
  travellerDetailUpdateSuccessfully: "Traveller Detail Update Successfully",
  unsubscriptionConfirmationMessage: "Are you sure you want to unsubscribe?",
  deleteAccountWarningBottomSheetDes:
    "Deleting the user will delete all the data associated with the account, and it is not reversible",
  enterYourPNRBookingReferenceNumber: "Enter Your PNR/Booking Reference Number",
  iAmNotResidingInNayContainmentZone: "I am not residing in any containment zone-",
  myBookingPopupOptionsCancelBooking: "Cancel booking",
  myBookingPopupOptionsChangeBooking: "Change booking",
  allBookingRelatedInfoWillBeSentHere: "All booking related communication will be sent here",
  arrivalDateBeforeDepartureErrorText: "Arrival date should be after departure date",
  dangerousGoodsAndRestrictedArticles: "Prohibited or Restricted Articles for air travel",
  enterRegisteredCompanyNameErrorText: "Please enter registered company name",
  generalCheckPassengerRestrictionMsg: "Web check in not allowed",
  getPremiumSeatsMealsPriorityCheckin:
    "Get premium seats, meals & priority checkin, baggage & boarding with Akasa Premium",
  profileUpdateConsentWithBookingInfo: "Update contact details in my profile. This will replace your existing details",
  returnDateLessThenDepartureErrorMsg: "Return flight has to be later than departure date",
  seatsSuccessfullyAddedToYourBooking: "Seat(s) successfully added to your booking",
  addOnsSuccessfullyAddedToYourBooking: "Add on(s) successfully added to your booking",
  boardingPassesAutoAssignCheckInTitle: "Boarding Pass",
  customizeBundleFareAddOnsDescription: "{} consist of complimentary meal and discounted seat. Please selected your",
  deleteAccountWarningBottomSheetTitle: "Are you sure to delete?",
  enterRegisteredEmailAddressErrorText: "Please enter registered email address",
  errorMobileNumberExistWithAnotherAcc: "Mobile number exists with another account",
  healthProfessionalsSpecialDescription:
    "Discount on Base fare for Doctors, Nurses & Paramedics across the country. Must submit a valid Healthcare professional ID/Registration number at the time of check-in for each passenger. This discount cannot be combined with any other offer. Terms & Conditions apply.",
  heresHowYourJourneyHasBeenSoFarWithUs: "Here’s how your journey has been so far with us.",
  informationWeCanAccessAndWhatWeCannot: "You get to choose what information we can access and what we cannot.",
  iAmEligibleToTravelAsPerTheExtantNorms: "I am eligible to travel as per the extant norms",
  webCheckIinIsNotPossibleForThisBooking:
    "Web check-in is not possible for this booking. Please complete your check-in formalities at the airport where we can assist you better.",
  iDonotHaveAnyProhibitedItemsInMyBaggage: "I don’t have any prohibited items in my baggage",
  myBookingPopupOptionsCancelFlightBooking: "Cancel flight",
  bookingOnHoldcompletePaymentByDateAndTime: "Booking on-hold. Complete payment by {date}, {time}",
  keepYourWorkTripsSeparateFromBusinessTrip: "Keep your work trips separate from business trip",
  yourBaggageTagsHasBeenGeneratedSuccessful: "Your baggage tags had been generated successful!",
  boardingPassesAutoAssignCheckInDescription:
    "Your boarding pass/passes with the assigned seat number will be sent to your registered email, six hours before flight departure.",
  addOnsAndSeatsSuccessfullyAddedToYourBooking: "Add on(s) and seats successfully added to your booking",
  languageCurrencyAccessibilityLoginPreferences: "Language, currency, accessibility and login preferences",
  retrieveYourBookingWithoutPNRUsingDetailsBelow: "Retrieve your booking without a PNR using the details below",
  iHaveNotTestedCOVID19PositiveInTheLastThreeWeeks: "I have not tested COVID-19 positive in the last three weeks",
  doNotCarryDangerousGoodsInYourBaggageOrOnYourPerson:
    "Please review the list of restricted and prohibited articles and do not carry these in your baggage or on your person",
  iAmNotSufferingFromAnyFeverCoughOrAnyRespiratoryDistress:
    "I am not suffering from any fever, cough or any respiratory distress",
  iHaveAllTheNecessaryTravelDocumentsNeededForThisItineraryAndIUnderstand:
    "I have all the necessary travel documents needed for this itinerary and I understand",
  iHaveReadAndUnderstoodAllTheUnderstandAllTheImportantSecurityInformation:
    "I have read and understood the safety and security information and shall comply with the same.",
  iWillAdhereToTheHealthProtocalPrescribedByTheDestinationStateUnionTerritory:
    "I will adhere to the health protocol prescribed by the destination state/union territory",
  iMustWearAFaceMaskForTheDurationOfTheFlightInAccordanceWithAkasaProtocolsForTheSafetyOfAllPassengers:
    "I must wear a face mask for the duration of the flight in accordance with Akasa protocols for the safety of all passengers",
  onlineCheckInOpens48HoursPriorToDepartureAFacilitationFeeOf200IsApplicableForAirportCheckInWithAssistance:
    "Online check-in is available from 48 hours up to 1 hour before flight departure.",
  webcheckIinIsNotPossibleForThisBookingPleaseCompleteYourCheckInFormalitiesAtTheAirportWhereWeCanAssistYouBetter:
    "Web check-in is not possible for this booking. Please complete your check-in formalities at the airport where we can assist you better",
  extraSeatErrorTitle:"Extra Seat",
  extraSeatErrorMsg:"Since you have opted for Extra Seat, you must select seats which are available next to each other.",
};
